import React, { useEffect, useCallback, useContext, useMemo, useState, useRef } from "react";

import { logoutRef } from "@stadium/services/auth/client";
import { useAuth0V2 } from "@stadium/services/auth0";
import { useMutation } from "@stadium/services/apollo-client";
import useRouter from "@stadium/hooks/lib/use-custom-route";
import { SloContext } from "@stadium/hooks/lib/use-slo";

import { logoutCommonParamsWithGenericCallback } from "@services/auth";
import { getPubNubServiceInstance } from "@services/pubnub";
import { createSession } from "@graphql/mutations/session/create";

import { CurrentUserContext } from "@contexts/current-user-provider";

export { SloContext };

const SloWrapper = ({ children }) => {
  const { isAuthenticated, logout } = useAuth0V2();
  const { asPath } = useRouter();
  const [createSessionRequest] = useMutation(createSession);
  const { currentUserData } = useContext(CurrentUserContext);
  const { spreeId: userId } = currentUserData;
  const [uid, setUid] = useState();
  const [sloChannel, setSloChannel] = useState();

  const currentPathRef = useRef();
  currentPathRef.current = asPath;

  const createSessionHandler = useCallback(
    (userAgent) => {
      return createSessionRequest({ variables: { input: { userAgent } } });
    },
    [createSessionRequest],
  );

  useEffect(() => {
    let pubnub = null;

    if (isAuthenticated && userId) {
      const pbListener = {
        message: (messageEvent) => {
          if (logoutRef?.current) return;
          if (messageEvent.message?.slo === true) {
            logout(logoutCommonParamsWithGenericCallback(currentPathRef.current));
          }
        },
      };

      createSessionHandler(window.navigator.userAgent)
        .then(({ data }) => {
          const { uid, channel } = data?.createSession || {};
          setUid(uid);
          setSloChannel(channel);
          getPubNubServiceInstance(uid).then((pubnubService) => {
            pubnub = pubnubService;
            pubnub.addListener(pbListener);
            pubnub.subscribe({ channels: [channel] });
          });
        })
        .catch((error) => {
          throw error;
        });
      return () => {
        if (pubnub) {
          pubnub.removeListener(pbListener);
          pubnub.unsubscribeAll();
        }
      };
    }
  }, [isAuthenticated, userId, createSessionHandler]);

  const value = useMemo(() => {
    return { sloChannel, uid };
  }, [sloChannel, uid]);

  return <SloContext.Provider value={value}>{children}</SloContext.Provider>;
};

export default SloWrapper;
